<template>
  <div class="landing-layout">
    <MatBanner
      v-if="showMatBanner"
      :handle-c-t-a-button-click="handleCTAButtonClick"
      :incentive="corporate.activeIncentive"
    />
    <LandingStickyHeader
      :handle-c-t-a-button-click="handleCTAButtonClick"
      :show-sticky-header="showStickyHeader"
    />
    <StartJourneyMsk
      :cta-btn-title="$t('b2b__landing_page__generic__cta_btn__lets_go')"
      :handle-c-t-a-button-click="handleCTAButtonClick"
      :receive-c-t-a-button-client-rect="receiveCTAButtonClientRect"
      :variant="variant"
    />
    <ReclaimingLife
      :cta-btn-title="$t('b2b__landing_page__generic__cta_btn__title')"
      :handle-c-t-a-button-click="handleCTAButtonClick"
      :variant="variant"
    />
    <VideoTestimonials />
    <Landing3Steps
      :cta-btn-title="$t('b2b__landing_page__generic__cta_btn__short_title')"
      :handle-c-t-a-button-click="handleCTAButtonClick"
    />
    <FaqModule />
    <Contacts />
    <FooterLanguage />
    <FooterCertificates />
    <FooterLinks />
  </div>
</template>

<script setup>
import { setPageTitle } from '@shared/utils'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import { computed, ref, watch } from 'vue'
import ROUTE from '@us/app/router/appModule/names'
import Contacts from '@us/app/components/Contacts.vue'
import FaqModule from '@shared/components/FaqModule.vue'
import Landing3Steps from '@shared/components/Landing3Steps.vue'
import LandingStickyHeader from '@shared/components/LandingStickyHeader.vue'
import ReclaimingLife from '@shared/components/ReclaimingLife.vue'
import StartJourneyMsk from '@us/app/components/StartJourneyMSK.vue'
import { useI18n } from 'petite-vue-i18n'
import { useRouter } from 'vue-router'
import FooterLinks from '@us/app/components/FooterLinks.vue'
import FooterCertificates from '@us/app/components/FooterCertificates.vue'
import FooterLanguage from '@us/app/components/FooterLanguage.vue'
import useMetaPixel, { META_PIXELS } from '@shared/composables/useMetaPixel.js'
import VideoTestimonials from '@us/app/components/VideoTestimonials.vue'
import MatBanner from '@us/app/components/MatBanner.vue'
import { INCENTIVE_VARIANTS } from '@shared/data/models/corporate.js'
import usePersistedConfigStore from '@shared/stores/usePersistedConfigStore.js'
import useSharedStore from '@shared/stores/useSharedStore.js'

const { t } = useI18n()
const corporateStore = useCorporateStore()
const sharedStore = useSharedStore()
const persistedConfigStore = usePersistedConfigStore()

const router = useRouter()

const corporate = computed(() => corporateStore.corporate)
const getCTAButtonClientRect = ref(() => {})
const variant = computed(() => sharedStore.initialQuery.variant)

const showMatBanner = computed(
  () => persistedConfigStore.incentive === INCENTIVE_VARIANTS.mat,
)

const showStickyHeader = () => {
  const rect = getCTAButtonClientRect.value()
  return rect != null && rect.top <= -rect.height / 2
}

const receiveCTAButtonClientRect = (clientRect) => {
  getCTAButtonClientRect.value = clientRect
}

const handleCTAButtonClick = () => {
  if (corporate.value) {
    router.push({ name: ROUTE.SELECT_VERIFICATION_METHOD })
  } else {
    router.push({ name: ROUTE.PARTNER_SEARCH })
  }
}

watch(
  corporate,
  (corporate) => {
    setPageTitle(
      [
        corporate?.title ? `${corporate.title} | ` : '',
        t('b2b__landing_page__generic__page_title'),
      ].join(''),
    )
  },
  { immediate: true },
)

const metaPixel = META_PIXELS[corporate.value?.key]
if (metaPixel && sharedStore.initialQuery?.utm_medium) useMetaPixel(metaPixel)
</script>

<style lang="scss">
.landing-layout {
  width: 100%;
  min-width: 320px;
  margin: 0 auto;
}
</style>
